<script>
	export default {
		name: 'CriteriumExecuter',
		methods: {
			setCriterium(code, name, description) {
				const self_ = this;

				const criterium_ = {
					name: name,
					description: description
				}
				return self_.setFirestoreDocument('criteria', code, criterium_)
			},
			deleteCriterium(code) {
				const self_ = this;
				return self_.deleteFirestoreDocument('criteria', code)
			}
		}
	}
</script>
